import React, { useState, useEffect } from "react";
import {getBalanceApi, loginApi} from '../../services/authApi'
import { t, getLang } from "../../lang";
export default function Login({ isOpen, onClose, onLoginSuccess }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberPassword, setRememberPassword] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [lang, setLangState] = useState(getLang());

  useEffect(() => {
    const handler = () => setLangState(getLang());
    window.addEventListener("langChanged", handler);
    return () => window.removeEventListener("langChanged", handler);
  }, []);
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      setError(""); // Reset error when modal opens
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      // Make POST request with query parameters and request body
      const response = await await loginApi(username, password);

      if (response.data.status === true) {
        // Save token and user data to localStorage
        const { token, token_type, user } = response.data.data;
        localStorage.setItem('authToken', token);
        localStorage.setItem('tokenType', token_type);
        localStorage.setItem('userData', JSON.stringify(user));
        localStorage.setItem('isAuthenticated', 'true');

        // Fetch user balance info after successful login
        try {
          const balanceResponse = await getBalanceApi();
          
          if (balanceResponse.data && balanceResponse.data.status === true) {
            const balanceData = balanceResponse.data.data;
            localStorage.setItem('userBalance', JSON.stringify(balanceData));
            
            // Dispatch custom event for same-tab updates
            window.dispatchEvent(new CustomEvent('balanceUpdated', {
              detail: { balanceData }
            }));
            
            // Call success callback with user data and balance data
            if (onLoginSuccess) {
              onLoginSuccess(user, token, balanceData);
            }
          } else {
            // Call success callback even if balance fetch fails
            if (onLoginSuccess) {
              onLoginSuccess(user, token, null);
            }
          }
        } catch (balanceError) {
          console.error("Error fetching balance:", balanceError);
          // Call success callback even if balance fetch fails
          if (onLoginSuccess) {
            onLoginSuccess(user, token, null);
          }
        }
      } else {
        setError(response.data.message || "Login failed");
      }
    } catch (err) {
      // Handle error response
      if (err.response && err.response.data) {
        setError(err.response.data.message || "Login failed. Please check your credentials.");
      } else {
        setError("Network error. Please try again.");
      }
      console.error("Login error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="login-overlay" onClick={onClose}></div>
      <div className="login-modal">
        <button className="login-close-btn" onClick={onClose}>
          <span>×</span>
        </button>
        
        <form className="login-form" onSubmit={handleSubmit}>
          <h2 className="login-title">{t("common.login")}</h2>
          
          {error && (
            <div className="login-error">
              {error}
            </div>
          )}
          
          <div className="login-field">
            <label className="login-label">{t("common.user_name")}</label>
            <input
              type="text"
              className="login-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder={t('common.user_name_place_holder')}
            />
          </div>
          
          <div className="login-field">
            <label className="login-label">{t("common.pass_word")}</label>
            <input
              type="password"
              className="login-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={t('common.password_place_holder')}
            />
          </div>
          
          <div className="login-checkbox-container">
            <input
              type="checkbox"
              id="remember-password"
              className="login-checkbox"
              checked={rememberPassword}
              onChange={(e) => setRememberPassword(e.target.checked)}
            />
            <label htmlFor="remember-password" className="login-checkbox-label">
              {t("common.remember_password")}
            </label>
          </div>
          
          <button type="submit" className="login-submit-btn" disabled={isLoading}>
            {isLoading ? t("common.logging_in") : t("common.login")}
          </button>
        </form>
      </div>
    </>
  );
}

